import * as types from "./types";

export const authenticationInProgress = _ => ({
  type: types.AUTHENTICATION_IN_PROGRESS
});

export const authenticationSuccessful = (access_token, refresh_token) => ({
  type: types.AUTHENTICATION_SUCCESSFUL,
  access_token: access_token,
  refresh_token: refresh_token
});

export const authenticationFailed = _ => ({
  type: types.AUTHENTICATION_FAILED
});

export const registrationInProgress = _ => ({
  type: types.REGISTRATION_IN_PROGRESS
});

export const registrationSuccessful = _ => ({
  type: types.REGISTRATION_SUCCESSFUL
});

export const registrationFailed = _ => ({
  type: types.REGISTRATION_FAILED
});

export const registrationAndLoginIsFinished = _ => ({
  type: types.REGISTRATION_AND_LOGIN_IS_FINISHED
});

export const passwordResetRequestInProgress = _ => ({
  type: types.PASSWORD_RESET_REQUEST_IN_PROGRESS
});

export const passwordResetRequestSuccess = _ => ({
  type: types.PASSWORD_RESET_REQUEST_SUCCESS
});

export const passwordResetRequestFailed = _ => ({
  type: types.PASSWORD_RESET_REQUEST_FAILED
});

export const userIsLoading = _ => ({
  type: types.USER_IS_LOADING
});

export const getUser = user => ({
  type: types.GET_USER,
  user: user
});

export const userIsNotAvailable = _ => ({
  type: types.USER_IS_NOT_AVAILABLE
});

export const logout = _ => ({
  type: types.LOGOUT
});
export const clearIamState = _ => ({
  type: types.CLEAR_STATE
});
export const changeUserNameInProgress = _ => ({
  type: types.CHANGE_USER_NAME_IN_PROGRESS
});

export const changeUserNameSuccessful = _ => ({
  type: types.CHANGE_USER_NAME_SUCCESSFUL
});

export const changeUserNameFailed = _ => ({
  type: types.CHANGE_USER_NAME_FAILED
});

export const changePasswordInProgress = _ => ({
  type: types.CHANGE_PASSWORD_IN_PROGRESS
});

export const changePasswordSuccessful = _ => ({
  type: types.CHANGE_PASSWORD_SUCCESSFUL
});

export const changePasswordFailed = _ => ({
  type: types.CHANGE_PASSWORD_FAILED
});

export const confirmPasswordInProgress = _ => ({
  type: types.CONFIRM_PASSWORD_IN_PROGRESS
});

export const confirmPasswordSuccessful = _ => ({
  type: types.CONFIRM_PASSWORD_SUCCESSFUL
});

export const confirmPasswordFailed = _ => ({
  type: types.CONFIRM_PASSWORD_FAILED
});

export const updateAccessTokenInProgress = _ => ({
  type: types.UPDATE_ACCESS_TOKEN_IN_PROGRESS
});

export const updateAccessTokenSuccess = accessToken => ({
  type: types.UPDATE_ACCESS_TOKEN_SUCCESS,
  access_token: accessToken
});

export const updateAccessTokenFailed = _ => ({
  type: types.UPDATE_ACCESS_TOKEN_FAILED
});

export const updateRequiredExperiencesInProgress = _ => ({
  type: types.UPDATE_REQUIRED_EXPERIENCES_IN_PROGRESS
});

export const updateRequiredExperiencesSuccessful = updatedValue => ({
  type: types.UPDATE_REQUIRED_EXPERIENCES_SUCCESSFUL,
  updatedValue: updatedValue
});

export const updateRequiredExperiencesFailed = _ => ({
  type: types.UPDATE_REQUIRED_EXPERIENCES_FAILED
});
